import { ComplexStatus } from 'src/constants/complexStatus';
import { ILanguage } from 'src/typings/language';
import { IComplex, IDeveloper } from 'src/typings/complexes';
import { ICountry } from 'src/typings/countries';

export type ComplexInitialDataDeveloper = Pick<IDeveloper, '@type' | '@id' | 'id' | 'name'>;

export interface ComplexInitialData {
  complexStatuses: ComplexStatus[],
  countryCodes: ICountry[],
  developers: ComplexInitialDataDeveloper[],
  languageCodes: ILanguage[],
}

export type CreatEditComplexData = Omit<IComplex, 'developers'> & {
  developers: ComplexInitialDataDeveloper[] | string[];
};

export const complexRequestProperties = {
  properties: {
    0: 'id',
    1: 'title',
    2: 'previewFileUri',
    3: 'logoFileUri',
    4: 'complexShortName',
    5: 'language',
    6: 'status',
    developers: [
      'iconUri',
      'logoFileUri',
    ],
  },
  order: {
    id: 'desc',
  },
};
